const MtrDotsDragOutline = {
  name: 'mtr-dots-drag',
  theme: 'outline',
  icon: {
    tag: 'svg',
    attrs: {
      viewBox: '0 0 24 24',
    },
    children: [
      {
        tag: 'g',
        attrs: {
          fill: 'currentColor',
          'fill-rule': 'evenodd',
        },
        children: [
          {
            tag: 'circle',
            attrs: {
              cx: '15',
              cy: '6',
              r: '2',
            },
          },
          {
            tag: 'circle',
            attrs: {
              cx: '9',
              cy: '12',
              r: '2',
            },
          },
          {
            tag: 'circle',
            attrs: {
              cx: '15',
              cy: '12',
              r: '2',
            },
          },
          {
            tag: 'circle',
            attrs: {
              cx: '9',
              cy: '18',
              r: '2',
            },
          },
          {
            tag: 'circle',
            attrs: {
              cx: '15',
              cy: '18',
              r: '2',
            },
          },
          {
            tag: 'circle',
            attrs: {
              cx: '9',
              cy: '6',
              r: '2',
            },
          },
        ],
      },
    ],
  },
};
export default MtrDotsDragOutline;
